var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slds-text-heading_medium slds-text-align_center"},[_vm._v(" "+_vm._s(_vm.$t('general.logoutOk'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }